import {
  List, Datagrid, EmailField, BooleanField, DateField, EditButton, Edit, SimpleForm,
  TextInput, BooleanInput, ExportButton, TopToolbar, FilterButton,
} from 'react-admin';
import { Stack } from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

const filters = [
  <TextInput key="q" source="q" label="Search email" alwaysOn />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

const SubscriberList = () => (
  <List sort={{ field: 'createdAt', order: 'DESC' }} filters={filters} actions={<ListActions />} perPage={50}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <EmailField source="email" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="createdAt" label="Subscribed" />
      <EditButton />
    </Datagrid>
  </List>
);

const SubscriberEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm>
      <Stack spacing={2} sx={{ maxWidth: 480 }}>
        <TextInput source="email" disabled fullWidth />
        <BooleanInput source="isActive" />
      </Stack>
    </SimpleForm>
  </Edit>
);

export default {
  list: SubscriberList,
  edit: SubscriberEdit,
  icon: MarkEmailReadIcon,
  options: { label: 'Newsletter' },
  recordRepresentation: 'email',
};
